import React, {Component} from 'react';
import {PURPLE_GRADIENT_TO_LEFT} from "../Constants/Colors";

export default class Footer extends Component {

	render() {
		return (
			<div className="no-print"
					 style={{
					 	 fontSize: "0.75rem",
						 lineHeight: "1rem",
						 textAlign: "center",
						 borderTop: "1px solid #ccc",
						 padding: "1rem",
						 backgroundImage: PURPLE_GRADIENT_TO_LEFT
					 }}>
				<p className="text-light">Last Updated: October 2020</p>
				<p className="text-secondary">Created my free logo at <a className="text-secondary" rel="noopener noreferrer"
																																 target="_blank"
																																 href="https://LogoMakr.com">LogoMakr.com</a></p>
				{/*<div className="text-light">*/}
				{/*	<div>*/}
				{/*		{"Total Page Views: "}*/}
				{/*		<a href="https://smallseotools.com/visitor-hit-counter/" rel="noopener noreferrer" target="_blank"*/}
				{/*			 title="Visitor Hit Counter">*/}
				{/*			<img*/}
				{/*				src="https://smallseotools.com/counterDisplay?code=b4c21a0c27e095dba554ba2fd2e4093a&style=0013&pad=6&type=page&initCount=0"*/}
				{/*				title="Visitor Hit Counter" alt="Visitor Hit Counter" border="0"/>*/}
				{/*		</a>*/}
				{/*	</div>*/}
				{/*	<br/>*/}
				{/*	<div>*/}
				{/*		{"Unique Visitors: "}*/}
				{/*		<a href="https://smallseotools.com/visitor-hit-counter/" rel="noopener noreferrer" target="_blank"*/}
				{/*			 title="Visitor Hit Counter">*/}
				{/*			<img*/}
				{/*				src="https://smallseotools.com/counterDisplay?code=b4c21a0c27e095dba554ba2fd2e4093a&style=0013&pad=5&type=ip&initCount=0"*/}
				{/*				title="Visitor Hit Counter" alt="Visitor Hit Counter" border="0"/>*/}
				{/*		</a>*/}
				{/*	</div>*/}
				{/*</div>*/}

			</div>
		);
	}
}